<template>
    <div>
        <div>软件综合明细</div>
        <div class="header">
            <span>刷新</span>
            <span>日期</span>
            <input type="text">
            <span>至</span>
            <input type="text">
            <span>搜索</span>
        </div>
        <el-table
            :data="data"
            style="width: 100%">
            <el-table-column prop="prop" label="软件名称" width="width"> </el-table-column>
            <el-table-column prop="prop" label="彩种" width="width"> </el-table-column>
            <el-table-column prop="prop" label="发布时间" width="width"> </el-table-column>
            <el-table-column prop="prop" label="定制/购买/破解/新开发" width="width"> </el-table-column>
            <el-table-column prop="prop" label="是否自动更新开奖" width="width"> </el-table-column>
            <el-table-column prop="prop" label="无病毒承诺/售后保证" width="width"> </el-table-column>
            <el-table-column prop="prop" label="价格区间" width="width"> </el-table-column>
            <el-table-column prop="prop" label="操作(平台工作人员审核)" width="width"> </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>